import { Box, BoxProps, Heading, Text } from "@vinomofo/components";

import { COLORS } from "../../styles";
import { UrgencyMessage } from "../../types";
import styled from "styled-components";

export interface OfferCtaMessageProps extends BoxProps {
  message: UrgencyMessage;
  isTierEligible?: boolean;
  isSpirit?: boolean;
  showCountdown?: boolean;
}

const StyledText = styled(Text)<{ showCountdown: boolean; isSpirit: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-widtn: 210px;

  @media (max-width: 480px) {
    ${({ showCountdown, isSpirit }) =>
      showCountdown &&
      isSpirit &&
      `
        width: 78px;  
        text-align: left;
    `}
`;

export const OfferCtaMessage = ({
  message,
  isTierEligible,
  isSpirit,
  showCountdown,
  ...rest
}: OfferCtaMessageProps): JSX.Element => {
  const baseProps = {
    px: "10px",
    ...rest,
  };

  if (isTierEligible) {
    return (
      <Box
        bg={COLORS.black}
        {...baseProps}
        style={{ justifyContent: "center" }}
      >
        <Box mb={0} p="4px" display="flex" justifyContent="center">
          <Heading
            as="span"
            variant="xxs"
            color="primary"
            lineHeight="none"
            fontWeight={900}
            fontSize="12px"
          >
            VIM
          </Heading>
          <Heading
            as="span"
            variant="xxs"
            color="white"
            lineHeight="none"
            fontWeight={100}
            fontSize="12px"
          >
            &nbsp; Exclusive
          </Heading>
        </Box>
      </Box>
    );
  }

  const bgColor = message?.backgroundColor
    ? COLORS[message.backgroundColor] ?? message.backgroundColor
    : undefined;

  return (
    <Box bg={bgColor} {...baseProps} padding={["3px 10px", "3px 15px"]}>
      <StyledText
        textAlign={isSpirit && showCountdown ? "left" : "center"}
        fontSize={["12px", "13px"]}
        fontWeight={600}
        color={message.textColor ?? "white"}
        fontFamily={isSpirit ? "DM Sans, sans-serif" : "Graphik, sans-serif"}
        showCountdown={showCountdown}
        isSpirit={isSpirit}
      >
        {message?.description}
      </StyledText>
    </Box>
  );
};
